import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Modal from "../modal";
import { getModuloInt, actualizaModulo } from "../../services/modulos";
import { getUsuarioFind } from "../../services/user";
import { ErrorContext } from "../../utils/context/error";

function ModuleModal({ show, AreaI, AreaFId ,ModuloI, Tag, handleshow, handleFiltrar }) {

  const [areaId, setAreaId] = useState(0);
  const [moduloId, setModuloId] = useState(0);
  const [nombreMod, setNombreMod]= useState("");
  const [codigoMod, setCodigoMod] = useState("");
  const [usuarioId, setUsuarioId] = useState(0);
  const [nombreusr, setNombreUsr] = useState("");
  const [codigousr, setCodigoUsr] = useState("");
  const [Titulo, setTitulo] = useState("");
  const [activa, setActiva]= useState(false);
  const [habilita, setHabilita] = useState(false);
  const [data, setData] = useState([]);
  const [area, setArea] = useState([]);
  const { setShowToast, setOpciones } = ErrorContext();
  let timeout="";
 
  //-----------------------------
  const handleUsuario = async (query)=>{
    if (query.length > 3)
    {
      if (timeout) clearTimeout(timeout);
        timeout = setTimeout(function(){
                    Procesar(query);
                    clearTimeout(timeout);
                  },1000);
    }
  }
  //-------------------------------
  const Procesar= async (query)=>{
   setActiva(true);
   const response = await getUsuarioFind(query);
   if (response)
   {
    if (response.status === 200) {
       setData(response.data.data);
       setActiva(false);
    } else {
      const Mensaje = response.message;
      const opc = { type: "Danger", message: Mensaje, active: true };
      setOpciones(opc);
      setShowToast(true);
    }  
   }
  }

  //--------------------------------
  const handleCancel = async () => {
    handleshow(false);
  };
  
  //--------------------------------
  const handleAceptar = async () => {
    setHabilita(true);
    setShowToast(false);
    const response = await actualizaModulo({
      areaId,
      moduloId,
      nombreMod,
      codigoMod,
      usuarioId,
      Tag,
    });
    if (response) 
      {
        if (response.status === 200) 
          {
            handleFiltrar(AreaFId);
            handleshow(false);
          }  
        else 
        {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
        }
      }
    else 
        {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
        }  

    setHabilita(false);
  };
  
  //---------------------------------
  const fillModuloInt = async (AreaId, ModuloI) => {
    setShowToast(false);
    const response = await getModuloInt(AreaId, ModuloI);
    if (response) {
      if (response.status === 200) {
         setNombreMod(response.data.data[0]?.NombreMod||"");
         setCodigoMod(response.data.data[0]?.CodigoMod||"");
         setCodigoUsr(response.data.data[0]?.CodigoUsr||"");
         setNombreUsr(response.data.data[0]?.NombreResp||"");
         setUsuarioId(response.data.data[0]?.UsuarioId||0);
         setAreaId(AreaI);
         setModuloId(ModuloI);
         
         setArea(response.data.area);
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    }
  };

  //----------------------------------
  const handlefilas=(item)=>{
  setNombreUsr(item.NombreUsr);
  setUsuarioId(item.UsuarioId);
  setCodigoUsr(item.CodigoUsr);
  setData([]);
}  
  
  //----------------------------------
  useEffect(() => {
    if (show) {
      setNombreMod("");
      setCodigoMod("");
      setCodigoUsr("");
      setNombreUsr("");
      setUsuarioId(0);
      setAreaId(AreaI);
      setModuloId(ModuloI);
     
      fillModuloInt(AreaI, ModuloI);
      
      if (Tag !== 0) {
        if (Tag === 1) setTitulo("Editar Modulo (" + ModuloI + ")");
        if (Tag === 2) setTitulo("Eliminar Modulo (" + ModuloI + ")");
      } else {
        setModuloId(0);
        setTitulo("Nuevo Modulo");
      }
    }
  }, [show]);

  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
               <div className="flex lg:w-[26rem]">
                  <form noValidate className="flex flex-col w-full">
                      <div className="flex flex-col w-full h-full ">
                        <div className="w-full">
                          <label>Area</label>
                          <select id="area" name="area" value={areaId || 0} onChange={(e) => setAreaId(e.target.value)} label="Area" disabled={Tag === 2 || Tag === 1}>
                              <option value={0} disabled>
                                 Seleccionar una Area...
                              </option>
                              {area.map((item) => 
                                {
                                  return(
                                    <option key={item.AreaId} value={item.AreaId}>
                                       {item.NombreArea}
                                    </option>
                                  );
                                }
                              )
                              }
                          </select>
                        </div>

                        <div className="w-full mt-4">
                           <label>Código Módulo</label>
                           <input type="text" name='searchid' value={codigoMod || ""} placeholder="Ingresa el codigo para el Módulo" 
                            onChange={(e)=> setCodigoMod(e.target.value)}
                            autoComplete="off" 
                            disabled={Tag === 2}>
                          </input>
                        </div>

                        <div className="w-full mt-4">
                           <label>Nombre Módulo</label>
                           <input type="text" name='searchid' value={nombreMod || ""} placeholder="Ingresa el nombre para el Módulo" 
                            onChange={(e)=> setNombreMod(e.target.value)}
                            autoComplete="off" 
                            disabled={Tag === 2}>
                          </input>
                        </div>

                        <div className="w-full mt-4">
                           <label>Nombre o Identificación del Usuario</label>
                           <input type="text" name='searchid' value={nombreusr || ""} placeholder="Buscar Usuarios..." 
                                     onKeyUp={(e) => handleUsuario(e.target.value.toUpperCase())}
                                     onChange={(e)=> setNombreUsr(e.target.value)}
                                     autoComplete="off" 
                                     disabled={Tag === 2 || activa}
                           ></input>
                           <div className={ data.length >0 ? "block" : "hidden"}>
                              <table className="absolute z-10  bg-white border border-gray-300 rounded shadow-lg mt-1">
                                 <thead className="border-b border-stone-200 text-sm font-medium ">
                                   <tr>
                                      <th className="px-2.5 py-2 text-start font-medium">Documento</th>
                                      <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                                      <th className="px-2.5 py-2 text-start font-medium">Cargo</th>
                                   </tr>
                                 </thead>
                                 <tbody className="group text-sm text-stone-800 ">
                                    {data.map((item) => (
                                       <tr className="border-b border-stone-200 last:border-0" key={item.UsuarioId}  onClick={() => handlefilas(item)}>
                                          <td>{item.NumeroNit}</td>
                                          <td>{item.NombreUsr}</td>
                                          <td>{item.NombreCar}</td>
                                       </tr>
                                     ))}
                                 </tbody>
                              </table>      
                           </div>
                        </div>
                       </div> 
                        <div className="flex w-full gap-4 mt-6 justify-end">
                          <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                          <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                        </div> 
                    </form>
      </div>                            
                      
                 
  
      </Modal>
    </>
  );
}
ModuleModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  AreaFId: PropTypes.number.isRequired, 
  ModuloI: PropTypes.number.isRequired, 
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleFiltrar: PropTypes.func.isRequired,
};

export default ModuleModal;
